import { Check, type LucideIcon } from 'lucide-react';

export const BooleanIcon: LucideIcon = Check;
